<template>
  <v-container fluid grid-list-xl>
    <v-layout row justify-center wrap>
      <v-flex lg6 sm9 xs12>
        <transition name="fade" mode="out-in">
          <div>
            <v-text-field
              :label="labels.uuid"
              v-model="loteCertificados.id"
              outline
              readonly
            ></v-text-field>
            <v-text-field
              :label="labels.nombre"
              v-model="loteCertificados.nombre"
              @click:append="editarLoteCertificados('nombre')"
              :append-icon="loteCertificados.estado !== 'enviado' ? 'edit' : ''"
              outline
              readonly
            ></v-text-field>
            <v-text-field
              :label="labels.campus"
              v-model="loteCertificados.nombre_campus"
              @click:append="editarLoteCertificados('nombre_campus')"
              :append-icon="loteCertificados.estado !== 'enviado' ? 'edit' : ''"
              outline
              readonly
            ></v-text-field>
            <v-text-field
              :label="labels.tipo_rvoe"
              v-model="loteCertificados.tipo_rvoe"
              @click:append="editarLoteCertificados('tipo_rvoe')"
              :append-icon="loteCertificados.estado !== 'enviado' ? 'edit' : ''"
              outline
              readonly
            ></v-text-field>
            <v-text-field
              :label="labels.fecha_capturado"
              v-model="loteCertificados.fecha_capturado"
              outline
              readonly
            ></v-text-field>
            <v-text-field
              :label="labels.fecha_autorizado"
              v-model="loteCertificados.fecha_autorizado"
              outline
              readonly
            ></v-text-field>
            <v-text-field
              :label="labels.fecha_firmado"
              v-model="loteCertificados.fecha_firmado"
              outline
              readonly
            ></v-text-field>
            <v-text-field
              :label="labels.folio_pago"
              v-model="loteCertificados.folio_pago"
              outline
              readonly
            ></v-text-field>
          </div>
        </transition>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  import axios from 'axios'
  import { mapGetters } from 'vuex'
  import { api } from '~/config'
  import Form from '~/mixins/form'

  export default {
    mixins: [Form],

    data: () => ({
      loteCertificados: {},
    }),

    computed: {
      ...mapGetters({
        live_mode: "auth/live_mode",
      })
    },

    watch: {
      live_mode(val) {
        if (val !== undefined) {
          this.$router.push({ name: 'lotes-certificados' })
        }
      }
    },

    mounted() {
      this.getLoteCertificados()
    },

    methods: {
      getLoteCertificados() {
        axios
          .get(api.path("lotes_certificados.single", { id: this.$route.params.id }))
          .then(res => {
            this.loteCertificados = res.data
          })
          .catch(err => {
            this.handleErrors(err.response.data.errors)
          })
          .then(() => {
          })
      },

      editarLoteCertificados(campo) {
        this.$router.push({ name: "lotes-certificados-editar", params: { 'campo': campo } })
      }
    }
  }
</script>
